import { SidenavService } from './../../services/sidenav.service';
import { DatePipe } from '@angular/common';
import { Component, Injectable, NgZone, OnInit } from '@angular/core';
import {
  NgbCalendar,
  NgbDate,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerConfig,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { DateService } from 'src/app/services/date.service';
import { ParkiteReportService } from 'src/app/services/parkite-report.service';
import { Workbook } from 'exceljs';
import { DownloadFileService } from '../../services/downloadfile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  standalone: false,
  selector: 'app-parkite-report',
  templateUrl: './parkite-report.component.html',
  styleUrls: ['./parkite-report.component.scss'],
})
export class ParkiteReportComponent implements OnInit {
  reportsList = [
    {
      index: '0',
      type: 'Fire Warden Report - Company',
      key: 'Company:Create',
      key1: 'Company:Edit',
      key2: 'Company:View'
    },
    {
      index: '1',
      type: 'VMS Report',
      key: 'VMS/Bulk Invite:Create',
      key1: 'VMS/Bulk Invite:Edit',
      key2: 'VMS/Bulk Invite:View'
    },
    {
      index: '2',
      type: 'Events Report',
      key: 'Events:Create',
      key1: 'Events:Edit',
      key2: 'Events:View'
    },
    {
      index: '3',
      type: 'Employee Report',
      key: 'Company:Create',
      key1: 'Company:Edit',
      key2: 'Company:View'
    },
    {
      index: '4',
      type: 'Payment of  Receipt Report',
      key: 'Company:Create',
      key1: 'Company:Edit',
      key2: 'Company:View'
    },
    {
      index: '5',
      type: 'Payment of Charge Report',
      key: 'Company:Create',
      key1: 'Company:Edit',
      key2: 'Company:View'
    },
    // {
    //   index: '6',
    //   type: 'RFID Report',
    // },
    {
      index: '6',
      type: 'Survey Report',
      key: 'Survey & Polls:Create',
      key1: 'Survey & Polls:Edit',
      key2: 'Survey & Polls:View'
    },
    {
      index: '7',
      type: 'Facility Report',
      key: 'Facility Booking:Create',
      key1: 'Facility Booking:Edit',
      key2: 'Facility Booking:View'
    },
    {
      index: '8',
      type: 'Meeting Room Report',
      key: 'Meeting Room:Create',
      key1: 'Meeting Room:Edit',
      key2: 'Meeting Room:View'
    },
  ];
  // prodReportsList = [
  //   {
  //     index: '0',
  //     type: 'Fire Warden Report - Company',
  //   },
  //   {
  //     index: '1',
  //     type: 'VMS Report',
  //   },
  //   {
  //     index: '3',
  //     type: 'Employee Report',
  //   },
  // ];
  prodReportsList = [
    {
      index: '0',
      type: 'Fire Warden Report - Company',
      key: 'Company:Create',
      key1: 'Company:Edit',
      key2: 'Company:View'
    },
    {
      index: '1',
      type: 'VMS Report',
      key: 'VMS/Bulk Invite:Create',
      key1: 'VMS/Bulk Invite:Edit',
      key2: 'VMS/Bulk Invite:View'
    },
    {
      index: '2',
      type: 'Events Report',
      key: 'Events:Create',
      key1: 'Events:Edit',
      key2: 'Events:View'
    },
    {
      index: '3',
      type: 'Employee Report',
      key: 'Company:Create',
      key1: 'Company:Edit',
      key2: 'Company:View'
    },
    {
      index: '4',
      type: 'Payment of  Receipt Report',
      key: 'Company:Create',
      key1: 'Company:Edit',
      key2: 'Company:View'
    },
    {
      index: '5',
      type: 'Payment of Charge Report',
      key: 'Company:Create',
      key1: 'Company:Edit',
      key2: 'Company:View'
    },
    // {
    //   index: '6',
    //   type: 'RFID Report',
    // },
    {
      index: '6',
      type: 'Survey Report',
      key: 'Survey & Polls:Create',
      key1: 'Survey & Polls:Edit',
      key2: 'Survey & Polls:View'
    },
    {
      index: '7',
      type: 'Facility Report',
      key: 'Facility Booking:Create',
      key1: 'Facility Booking:Edit',
      key2: 'Facility Booking:View'
    },
    {
      index: '8',
      type: 'Meeting Room Report',
      key: 'Meeting Room:Create',
      key1: 'Meeting Room:Edit',
      key2: 'Meeting Room:View'
    },
  ];
  paymentTypes: any = [
    {
      id: 2,
      paymentType: 'Facility booking',
    },
    {
      id: 3,
      paymentType: 'Meeting Room',
    },
    {
      id: 1,
      paymentType: 'Parking Management System (PMS)',
    },
  ];
  paymentStatysTypes: any = [
    {
      id: 'All',
      paymentStatusType: 'All',
    },
    {
      id: 'Success',
      paymentStatusType: 'Success',
    },
    {
      id: 'Pending',
      paymentStatusType: 'Pending',
    },
    {
      id: 'Failure',
      paymentStatusType: 'Failure',
    },
  ];
  worksheet;
  workbook;
  PdfReportrows = [];
  selectedIndex: number = 0;
  totalRows: number = 0;
  DownloadTypes: any = [
    { id: '1', type: 'Download as PDF' },
    { id: '2', type: 'Download as Excel' },
  ];
  paymentDownloadType: any = [{ id: '2', type: 'Download as Excel' }];

  activityType: any[] = [
    { id: 1, name: 'Fire Drill' },
    { id: 2, name: 'Events' },
  ];
  selectedActivityType: any;
  selectedActivityTypeId: any;
  selectedInviteType: any;
  page: any;
  fDate: string;
  tDate: string;
  toDate: any;
  fromDate: any;
  formattedSelectedToDate: string = '';
  formattedSelectedDate: string = '';
  selectedDate: any;
  selectedToDate: string;
  searchText: string = '';
  selectedEventCat: any;
  selectedEventCatId: any;
  eventCategory: any[] = [
    { id: '{00000000-0000-0000-0000-000000000000}', name: 'All' },
  ];
  vmsStatus: any[] = [
    { id: '1', name: 'All' },
    { id: '2', name: 'With Access' },
    { id: '3', name: 'Without Access' },
    { id: '4', name: 'Pending Approval' },
  ];
  selectedVmsStatus: any;
  selectedVmsStatusId: any;
  isDesc: boolean = false;
  column: string = 'MeetingRoom';
  pageNo: number = 1;
  indexPage = 1;
  pageSize: number = 10;
  employeesList: any[] = [];
  SelectedDownloadReportType: any = [];
  fireWardenList: any[] = [];
  multiSelectionInvitationType: any = [];
  vmsList: any[] = [];
  reportsLoaded: boolean = false;
  invitationTypes: any;
  selectedInvitatoinTypeId: any;
  eventList: any[] = [];
  eventTypes: any;
  selectedEventTypeId: any;
  multiSelectioneventType: any[] = [];
  selctionEventlength: number;
  selectedEventType: any;
  selectedEventId: any;
  totalCount: number;
  allEventData: any[] = [];
  paymentModule: number = 1;
  paymentStatusTypeId: string = 'All';
  paymentData: any[] = [];
  paymentType;
  paymentStatusType;
  text;
  paymentReceiptData: any[] = [];
  prod: boolean = false;

  tenants: any;
  selectedOrganizationId: any;
  multiSelectionOrganizations: any = [];
  selectedOrganzation: any;
  listfrids: any;
  creditPoint: any;
  mainSurveyTypes = [];
  selectedSurveyName: any;
  listSurvey: any;
  mainFacilityTypes = [];
  mainMeetingRoomTypes = [];
  selectedFacilityName: any;
  selectedMeetingRoomName: any;
  listFacility: any;
  listMeetingRoom: any;
  buildingData: any;
  tenantData: any;
  tempDate: any;
  baseUrl;
  totalCountList: number = 0;
  errormessage: string = '';
  successmessage: string = '';
  eventCreate: any;
  vmsCreate: any;
  surveyCreate: any;
  facilityCreate: any;
  companyCreate: any;
  historyPage: boolean = false;
  eventView: any;
  vmsView: any;
  surveyView: any;
  facilityview: any;
  companyView: any;
  eventEdit: any;
  vmsEdit: any;
  surveyEdit: any;
  facilityEdit: any;
  companyEdit: any;
  finalReportList: { index: string; type: string; key: string; key1: string; key2: string; }[];
  meetingRoomCreate: any;
  meetingRoomEdit: any;
  meetingRoomView: any;

  constructor(
    public datepipe: DatePipe,
    private reportService: ParkiteReportService,
    private appStateSrv: AppStateProvider,
    private zone: NgZone,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private dateSrv: DateService,
    private downloadFileService: DownloadFileService,
    private sideNavService: SidenavService,
    private ActiveRoute: ActivatedRoute,
    private router: Router,
    private rolebasedactionService: RolebasedactionService,
  ) {
    if (window.location.host == 'csworkind-cla-prod.capitaland.com') {
      this.prod = true;
    } else {
      this.prod = false;
    }
    this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((events: RoutesRecognized[]) => {
        console.log('previous url', events[0].urlAfterRedirects);
        console.log('current url', events[1].urlAfterRedirects);
        this.selectedIndex = 3;
      });

    const route = this.sideNavService.routingChunks({ name: 'Reports' });
    this.appStateSrv.setSideNavState(route);

    this.DownloadTypes = [
      { id: '1', type: 'Download as PDF' },
      { id: '2', type: 'Download as Excel' },
    ];
    ngbDatepickerConfig.minDate = {
      year: 1970,
      month: 1,
      day: 1,
    };

    ngbDatepickerConfig.outsideDays = 'visible';
  }

  ngOnInit(): void {
    this.eventCreate = this.rolebasedactionService.checkUserRolePermissionExits('Events:Create');
    this.vmsCreate = this.rolebasedactionService.checkUserRolePermissionExits('VMS/Bulk Invite:Create');
    this.surveyCreate = this.rolebasedactionService.checkUserRolePermissionExits('Survey & Polls:Create');
    this.facilityCreate = this.rolebasedactionService.checkUserRolePermissionExits('Facility Booking:Create');
    this.companyCreate = this.rolebasedactionService.checkUserRolePermissionExits('Company:Create');
    this.meetingRoomCreate = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:Create');

    this.eventEdit = this.rolebasedactionService.checkUserRolePermissionExits('Events:Edit');
    this.vmsEdit = this.rolebasedactionService.checkUserRolePermissionExits('VMS/Bulk Invite:Edit');
    this.surveyEdit = this.rolebasedactionService.checkUserRolePermissionExits('Survey & Polls:Rdit');
    this.facilityEdit = this.rolebasedactionService.checkUserRolePermissionExits('Facility Booking:Edit');
    this.companyEdit = this.rolebasedactionService.checkUserRolePermissionExits('Company:Edit');
    this.meetingRoomEdit = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:Edit');

    this.eventView = this.rolebasedactionService.checkUserRolePermissionExits('Events:View');
    this.vmsView = this.rolebasedactionService.checkUserRolePermissionExits('VMS/Bulk Invite:View');
    this.surveyView = this.rolebasedactionService.checkUserRolePermissionExits('Survey & Polls:View');
    this.facilityview = this.rolebasedactionService.checkUserRolePermissionExits('Facility Booking:View');
    this.companyView = this.rolebasedactionService.checkUserRolePermissionExits('Company:View');
    this.meetingRoomView = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:View');

    this.eventEdit = this.rolebasedactionService.checkUserRolePermissionExits('Events:Edit');
    this.vmsEdit = this.rolebasedactionService.checkUserRolePermissionExits('VMS/Bulk Invite:Edit');
    this.surveyEdit = this.rolebasedactionService.checkUserRolePermissionExits('Survey & Polls:Rdit');
    this.facilityEdit = this.rolebasedactionService.checkUserRolePermissionExits('Facility Booking:Edit');
    this.companyEdit = this.rolebasedactionService.checkUserRolePermissionExits('Company:Edit');

    this.eventView = this.rolebasedactionService.checkUserRolePermissionExits('Events:View');
    this.vmsView = this.rolebasedactionService.checkUserRolePermissionExits('VMS/Bulk Invite:View');
    this.surveyView = this.rolebasedactionService.checkUserRolePermissionExits('Survey & Polls:View');
    this.facilityview = this.rolebasedactionService.checkUserRolePermissionExits('Facility Booking:View');
    this.companyView = this.rolebasedactionService.checkUserRolePermissionExits('Company:View');


    const permissionData = JSON.parse(localStorage.getItem('claAdminPermissions'));
    if (permissionData.modulePermission.length > 0) {
      this.reportsList = this.filterReports(this.reportsList, permissionData.modulePermission);
      this.prodReportsList = this.filterReports(this.prodReportsList, permissionData.modulePermission);
      // console.log(this.reportsList);
    }
    console.log(this.reportsList);

    this.baseUrl = environment.apiBaseUrlVegitation + 'api/v1/Survey/DownloadSurveyReport?surveyId=';
    const route = this.sideNavService.routingChunks({ name: 'Reports' });
    this.appStateSrv.setSideNavState(route);

    const jsDate = new Date();
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.fromDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.toDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();
    if (this.selectedActivityType == undefined) {
      this.selectedActivityType = this.activityType[0].name;
      this.selectedActivityTypeId = this.activityType[0].id;
    }
    if (this.prod == true) {
      this.finalReportList = this.prodReportsList;
    } else {
      this.finalReportList = this.reportsList;
    }
    console.log(this.finalReportList);
    this.selectedIndex = localStorage.getItem('temp') ? Number(localStorage.getItem('temp')) : 1;
    const result = this.getReportByIndex(this.finalReportList, this.selectedIndex);
    console.log(this.finalReportList);
    console.log(result);
    if (result === false) {
      this.selectedIndex = this.finalReportList.length;
    }
    this.showReportData();
  }

  getReportByIndex(reports, selectedIndex) {
    // Find the report with the matching index
    const selectedReport = reports.find(report => report.index === selectedIndex.toString());

    // If a match is found, return it; otherwise, return the 0th position
    return selectedReport ? true : false;
  }

  ngOnDestroy() {
    localStorage.removeItem('temp');
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  selectedReportType(item) {
    this.paymentModule = 1;
    this.paymentStatusTypeId = 'All';
    this.selectedIndex = parseInt(item);
    localStorage.setItem('temp', item);
    this.resetDate(item);
    this.pageNo = 0;
    this.pageSize = 10;
    this.page = 0;
    this.indexPage = 1;
    this.totalRows = 0;
    this.showReportData();
  }

  getinvitationTypes() {
    this.reportsLoaded = false;

    this.reportService.getInvitationType().subscribe((r) => {
      this.invitationTypes = r.list;
      this.selectedInvitatoinTypeId = null;
      const allOpt = {
        invitationTypeId: null,
        invitationType: 'All',
      };
      this.invitationTypes.unshift(allOpt);

      if (
        this.selectedInvitatoinTypeId == null &&
        this.invitationTypes.length > 0
      ) {
        this.selectedInvitatoinTypeId =
          this.invitationTypes[0].invitationTypeId;
        this.selectInviteType(this.invitationTypes[0]);
      }
      this.reportsLoaded = true;
    });
  }

  selectInviteType(item) {
    if (item.invitationTypeId !== null)
      if (this.multiSelectionInvitationType.includes(item.invitationTypeId))
        this.multiSelectionInvitationType.splice(
          this.multiSelectionInvitationType.indexOf(item.invitationTypeId),
          1
        );
      else this.multiSelectionInvitationType.push(item.invitationTypeId);
    else this.multiSelectionInvitationType = [];

    let length = this.multiSelectionInvitationType.length - 1;
    this.selctionlength = length;
    this.selectedInvitatoinTypeId = item.invitationTypeId;

    if (item.invitationType != 'All') {
      this.selectedType = this.invitationTypes.find(
        (x) =>
          x.invitationTypeId ==
          this.multiSelectionInvitationType[
          this.multiSelectionInvitationType.length - 1
          ]
      ).invitationType;
    } else {
      this.selectedType = item.invitationType;
    }
    // this.selectedInviteType = item.invitationType;
    this.page = 0;
    this.indexPage = 1;
    this.getVMSReportData();
  }

  selectedType: any;
  selctionlength: number;

  showReportData() {
    console.log('indexxx', this.selectedIndex);
    this.pageNo = 0;
    this.pageSize = 0;
    this.page = 0;
    this.indexPage = 1;
    this.totalRows = 0;
    switch (this.selectedIndex) {
      case 0:
        if (this.selectedActivityType == undefined) {
          this.selectedActivityType = this.activityType[0].name;
          this.selectedActivityTypeId = this.activityType[0].id;
        }
        this.getFirewardenReportData();
        this.totalRows = this.fireWardenList?.length;
        break;
      case 1:
        if (this.invitationTypes == null || this.invitationTypes == undefined)
          this.getinvitationTypes();
        this.getVMSReportData();
        // this.totalRows = this.vmsList?.length;
        break;
      case 2:
        if (this.selectedEventCatId == undefined) {
          this.selectedEventCatId = this.eventCategory[0].id;
          this.selectedEventCat = this.eventCategory[0].name;
        }
        this.getEventsCategory();
        this.getEventsReportData();
        break;
      case 3:
        if (this.selectedVmsStatus == undefined) {
          this.selectedVmsStatus = this.vmsStatus[0].name;
          this.selectedVmsStatusId = this.vmsStatus[0].id;
        }
        this.getEmployeeReportData();
        this.totalRows = this.employeesList.length;
        break;
      case 5:
        this.selectPaymentType(this.paymentModule);
        this.selectPaymentStatus(this.paymentStatusTypeId);
        // this.getPaymentReport();
        // this.totalRows = this.employeesList.length;
        break;
      case 4:
        this.selectPaymentType(this.paymentModule);
        this.selectPaymentStatus(this.paymentStatusTypeId);
        // this.getPaymentRecieptReport();
        // this.totalRows = this.employeesList.length;
        break;
      // case 6:
      //   this.selectedIndex = 6;
      //   this.getTentantsRfid();
      //   this.getRfidsReport();
      //   localStorage.removeItem('reportQuery');
      //   localStorage.removeItem('temp');
      //   break;
      case 6:
        this.selectedIndex = 6;
        this.getTypeSurvey();
        this.getSurveyReport();
        localStorage.removeItem('reportQuery');
        localStorage.removeItem('temp');
        break;
      case 7:
        this.selectedIndex = 7;
        this.getTypeFacility();
        this.getFacilityReport();
        localStorage.removeItem('reportQuery');
        localStorage.removeItem('temp');
        break;
      case 8:
        this.selectedIndex = 8;
        if (this.mainMeetingRoomTypes == null || this.mainMeetingRoomTypes == undefined || this.mainMeetingRoomTypes.length == 0)
          this.getTypeMeetingRoom();
        this.getMeetingRoomReport();
        localStorage.removeItem('reportQuery');
        localStorage.removeItem('temp');
        break;
    }
  }

  selectPaymentType(id) {
    this.paymentModule = id;
    this.paymentType = this.paymentTypes.filter(
      (el) => el.id == id
    )[0].paymentType;
    console.log(this.selectedIndex);
    if (this.selectedIndex == 4) this.getPaymentRecieptReport();
    if (this.selectedIndex == 5) this.getPaymentReport();
  }

  selectPaymentStatus(id) {
    this.paymentStatusTypeId = id;
    this.paymentStatusType = this.paymentStatysTypes.filter(
      (el) => el.id == id
    )[0].paymentStatusType;

    console.log(this.paymentStatusType);
    if (this.selectedIndex == 4) this.getPaymentRecieptReport();
    if (this.selectedIndex == 5) this.getPaymentReport();
  }

  getEmployeeReportData() {
    this.totalRows = 0;
    const employeeReportRequestModel = {
      vmsAccessType: this.selectedVmsStatusId,
      parkId: localStorage.getItem('parkId'),
      // fromDate: this.selectedDate,
      // toDate: this.selectedToDate,
      searchTerm: this.searchText,
      pageNo: this.pageNo,
      size: this.pageSize,
    };

    this.reportService.getEmployeeReports(employeeReportRequestModel).subscribe(
      (response: any) => {
        console.log('s', response);
        //let data = JSON.parse(response)
        // this.processApiResponse(response);
        this.employeesList = response.list;
        this.totalRows = this.employeesList?.length;
        if (this.employeesList?.length > 0) this.reportsLoaded = true;
        else this.reportsLoaded = false;
      },
      (err) => console.log('error', err)
    );
  }

  getPaymentReport() {
    this.totalRows = 0;
    const paymentModel = {
      paymentType: this.paymentModule,
      paymentStatusType: this.paymentStatusTypeId,
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      pageNo: 0,
      size: 0,
      parkId: localStorage.getItem('parkId'),
    };
    console.log(paymentModel);
    this.reportService.getPaymentReport(paymentModel).subscribe((res) => {
      console.log(res);
      if (this.paymentModule == 1) this.paymentData = res[0]?.pmsdetails;
      if (this.paymentModule == 2) this.paymentData = res[0]?.facilitydetails;
      if (this.paymentModule == 3) this.paymentData = res[0]?.meetingdetails;
      this.totalRows = this.paymentData?.length;
    });
  }

  getPaymentRecieptReport() {
    this.totalRows = 0;
    // this.paymentReceiptData=[]
    const paymentModel = {
      paymentType: this.paymentModule,
      paymentStatusType: this.paymentStatusTypeId,
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      //pageNo: 0,
      //size: 0,
      pageNo: this.pageNo,
      size: this.pageSize,
      parkId: localStorage.getItem('parkId'),
    };
    this.reportService
      .getPaymentRecieptReport(paymentModel)
      .subscribe((res) => {
        console.log(res);
        console.log('INNNN');
        console.log(this.paymentStatusTypeId);
        if (this.paymentModule == 1)
          this.paymentReceiptData = res[0]?.pmsdetails;
        if (this.paymentModule == 2)
          this.paymentReceiptData = res[0]?.facilitydetails;
        if (this.paymentModule == 3)
          this.paymentReceiptData = res[0]?.meetingdetails;
        this.totalRows = this.paymentReceiptData.length;
        if (this.paymentStatusTypeId != 'All') {
          console.log(this.paymentReceiptData);
          this.paymentReceiptData = this.paymentReceiptData.filter(
            (value) => value.paymentStatus == this.paymentStatusTypeId
          );
          this.totalRows = this.paymentReceiptData.length;
        }
      });
  }

  handelPaymentReceiptReport(event) {
    this.page = event;
    this.indexPage = this.page;
    this.getPaymentRecieptReport();
  }

  getEventsReportData() {
    this.totalRows = 0;
    const eventsReportRequestModel = {
      eventCategoryId:
        this.multiSelectioneventType.length == 0
          ? this.allEventData
          : this.multiSelectioneventType,
      eventFromDate: this.selectedDate,
      eventToDate: this.selectedToDate,
      searchText: this.searchText,
      pageNo: this.pageNo,
      size: this.pageSize,
      parkId: localStorage.getItem('parkId'),
    };
    this.totalCount = 100;

    this.reportService.getEventsReportData(eventsReportRequestModel).subscribe(
      (response: any) => {
        console.log('s', response);
        //let data = JSON.parse(response)
        // this.processApiResponse(response);
        this.eventList = response.list;
        this.totalRows = response.list?.length;
      },
      (err) => console.log('error', err)
    );
  }

  getDateFormat(dateInput) {
    let [year, month, date] = dateInput.split('T')[0].split('-');
    console.log(date, month, year);
    return date + '-' + month + '-' + year;
  }

  getEventsCategory() {
    this.reportsLoaded = false;

    this.reportService.getEventsCategory().subscribe((r) => {
      this.eventTypes = r.list;
      this.selectedEventTypeId = null;
      const allOpt = {
        eventCategoryId: null,
        eventCategoryName: 'All',
      };
      this.eventTypes.unshift(allOpt);

      if (this.selectedEventTypeId == null && this.eventTypes.length > 0) {
        this.selectedEventTypeId = this.eventTypes[0].eventTypeId;
        this.selectEventType(this.eventTypes[0]);
      }
      this.reportsLoaded = true;
    });
  }

  selectEventType(item) {
    console.log(
      (item.eventCategoryId == null &&
        this.multiSelectioneventType.includes(item.eventCategoryId)) ||
      (item.eventCategoryId == null &&
        (this.multiSelectioneventType.length == 0 ||
          this.multiSelectioneventType.length == this.eventTypes.length - 1))
    );

    this.allEventData = [];
    this.eventTypes.map((res) => {
      if (res.eventCategoryId !== null) {
        this.allEventData.push(res.eventCategoryId);
      }
    });
    if (item.eventCategoryId !== null) {
      if (this.multiSelectioneventType.includes(item.eventCategoryId))
        this.multiSelectioneventType.splice(
          this.multiSelectioneventType.indexOf(item.eventCategoryId),
          1
        );
      else this.multiSelectioneventType.push(item.eventCategoryId);
    } else {
      this.multiSelectioneventType = [];
    }

    let length = this.multiSelectioneventType.length - 1;
    this.selctionEventlength = length;
    this.selectedEventTypeId = item.eventCategoryId;

    if (item.eventType != 'All') {
      this.selectedEventType = this.eventTypes.find(
        (x) =>
          x.eventCategoryId ==
          this.multiSelectioneventType[this.multiSelectioneventType.length - 1]
      ).eventCategoryName;
    } else {
      this.selectedEventType = item.eventCategoryName;
    }

    if (this.multiSelectioneventType.length == this.eventTypes.length - 1) {
      this.multiSelectioneventType = [];
    }
    this.indexPage = 1;
    this.page = 0;
    this.getEventsReportData();
  }

  getFirewardenReportData() {
    this.totalRows = 0;
    const fireWardenReportInputModel = {
      employeetype: 1,
      scanType: this.selectedActivityTypeId, //  localStorage.getItem(AppConstant.localStorage.parkTenantId);
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      searchTerm: this.searchText,
      pageNo: this.pageNo,
      size: this.pageSize,
    };

    this.reportService
      .getFireWardenReportData(fireWardenReportInputModel)
      .subscribe(
        (response: any) => {
          console.log('s', response);
          //let data = JSON.parse(response)
          // this.processApiResponse(response);
          this.fireWardenList = response.data;
          this.totalRows = this.fireWardenList?.length;
          if (this.fireWardenList?.length > 0) this.reportsLoaded = true;
          else this.reportsLoaded = false;
        },
        (err) => console.log('error', err)
      );
  }

  /**
   * Fetches the VMS report data based on the specified input model.
   * 
   * This method initializes the total count list to zero and sets the page number to 1 if it is zero.
   * It constructs the VMSReportInputModel object with various parameters such as invitation type,
   * park ID, date range, search term, page number, and size. The `isAll` flag is set based on the 
   * length of the multi-selection invitation type.
   * 
   * The method then calls the `getVMSReportData` service method with the constructed input model.
   * On successful response, it updates the VMS list, total rows, and total count list. If the response
   * data is null or the VMS list is empty, it sets the reportsLoaded flag to false and resets the total
   * rows and total count list to zero.
   * 
   * @returns {void}
   */
  getVMSReportData() {
    this.totalCountList = 0;
    if (this.pageNo == 0) {
      this.pageNo = 1;
    }
    console.log('pageeee', this.page);
    const VMSReportInputModel = {
      invitationType: this.multiSelectionInvitationType,
      parkId: localStorage.getItem('parkId'),
      //invitationType: "individualInvite",
      // TenantId: "b8657e8d-c137-46a4-9de0-bdbb01b8fc04", //  localStorage.getItem(AppConstant.localStorage.parkTenantId);
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      searchTerm: this.searchText,
      // pageNo: this.page,
      // size: this.pageNo,
      pageNo: this.pageNo,
      size: 10, //this.pageSize,
      isAll: this.multiSelectionInvitationType.length == 0 ? true : false,
    };

    this.reportService.getVMSReportData(VMSReportInputModel).subscribe(
      (response: any) => {
        if (response.data != null) {
          console.log('s', response);
          this.vmsList = response.data?.vmsReportViewModels;
          this.reportsLoaded = true;
          this.totalRows = this.vmsList?.length;
          this.totalCountList = response.data.totalCount;
          if (this.vmsList?.length > 0) {
            this.reportsLoaded = true;
          } else {
            this.reportsLoaded = false;
            this.totalRows = 0;
            this.totalCountList = 0;
          }
        } else {
          this.reportsLoaded = false;
          this.totalRows = 0;
          this.totalCountList = 0;
        }
      },
      (err) => console.log('error', err)
    );
  }

  selectActivityType(value) {
    this.selectedActivityType = value.name;
    this.selectedActivityTypeId = value.id;
    this.showReportData();
  }

  handlePageChangeMeeting(event) {
    this.page = event;
    this.indexPage = this.page;
    console.log('pagination clicked');
    // // this.meetingRoom = this.invitationTypes.map(
    // //   (meeting: any, i: any) => ({ id: i + 1, ...meeting })).slice(
    // //     (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    // this.vmsList = this.vmsList.slice(
    //   0,
    //   this.vmsList.length < 10
    //     ? this.vmsList.length
    //     : (this.page - 1) * this.pageSize + this.pageSize
    // );
  }

  handlePageChangeVMS(event) {
    this.pageNo = event;
    this.page = event;
    this.indexPage = this.page;
    this.getVMSReportData();
  }

  handleEventPageChange(event) {
    this.page = event;
    this.indexPage = this.page;
    this.getEventsReportData();
  }

  public async updateSelectedDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    this.fromDate = jsDate;
    this.fDate = this.updateDateToCalendar(date);
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        this.showReportData();
      } else {
        this.zone.run(() => {
          this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
          this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
            new Date().getDate(),
            new Date().getMonth(),
            new Date().getFullYear()
          );
        });
        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        this.resetDate(this.selectedIndex);
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  resetDate(id) {
    const jsDate = new Date();
    this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );

    this.selectedToDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );

    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();

    this.fromDate = jsDate;
    this.toDate = jsDate;
    localStorage.setItem('temp', id);
    this.showReportData();
    // this.getVMSReportData()
    // window.location.reload();
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =
      date == undefined
        ? this.dateAdapter.toModel(this.ngbCalendar.getToday())!
        : this.dateAdapter.toModel(date)!;
    return updatedDate;
  }

  public async updateSelectedToDate(date: NgbDate) {
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.toDate = jsDate;
    this.tDate = this.updateDateToCalendar(date);
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );

    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        this.showReportData();
      } else {
        this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        2;
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(
          new Date().getDate(),
          new Date().getMonth(),
          new Date().getFullYear()
        );

        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        this.resetDate(this.selectedIndex);
        // this.selectedReportType(this.selectedIndex)
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  // selectEventCat(value) {
  //   this.selectedEventCat = value.name;
  //   this.selectedEventCatId = value.id;
  //   this.getEventsReportData();
  // }

  selectVmsStatus(value) {
    this.selectedVmsStatus = value.name;
    this.selectedVmsStatusId = value.id;
    this.showReportData();
  }

  sort(property, list) {
    console.log(property);
    this.isDesc = !this.isDesc; //change the direction
    this.column = property;
    let direction = this.isDesc ? 1 : -1;

    let sortedArray = list.sort(function (a, b) {
      if (a[property] < b[property]) {
        return -1 * direction;
      } else if (a[property] > b[property]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
    return sortedArray;
  }

  selectedReportDownload(item) {
    this.SelectedDownloadReportType = [];
    if (item.id !== null) {
      this.SelectedDownloadReportType.push(item.id);
    } else {
      this.SelectedDownloadReportType.push(1);
    }
    if (item.id == 2) {
      this.DownloadReport();
    } else if (item.id == 1) {
      this.DownloadReportPDF();
    }
  }

  dateFormat(date) {
    if (date !== null && date !== undefined) {
      return date?.length > 10 ? '+91' + date.substring(3) : '+91' + date;
    }
  }

  DownloadReport() {
    this.worksheet = null;
    this.pageNo = 0;
    this.pageSize = 0;
    let reportname;
    console.log(this.selectedIndex);
    if (this.selectedIndex == 0) {
      console.log('firewarden');
      this.workbook = new Workbook();
      reportname = 'Fire Warden Report - Company';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'ERT Members Company', key: 'ERTMembersCompany', width: 10 },
        { header: 'Activity Type', key: 'ActivityType', width: 10 },
        { header: 'ERT Member name', key: 'ERTMembername', width: 10 },
        {
          header: 'Scanned Employee Type',
          key: 'ScannedEmployeeType',
          width: 10,
        },
        {
          header: 'Scanned Employee Name',
          key: 'ScannedEmployeeName',
          width: 10,
        },
        {
          header: 'Scanned Employee Contact Number',
          key: 'ScannedEmployeeContactNumber',
          width: 10,
        },
        { header: 'Scan Date', key: 'ScanDate', width: 10 },
        { header: 'Scan Time', key: 'ScanTime', width: 10 },
        { header: 'Visitor Email', key: 'VisitorEmail', width: 10 },
        { header: 'Park Name', key: 'ParkName', width: 10 },
      ];

      let data;
      this.getFirewardenReportData();
      data = this.fireWardenList;
      let srNo: number = 0;
      data.forEach((e) => {
        srNo = srNo + 1;
        this.worksheet.addRow(
          {
            SrNo: srNo,
            ERTMembersCompany: e.ertCompnayName,
            ActivityType: this.selectedActivityType,
            ERTMembername: e.ertMbrName,
            ScannedEmployeeType: e.employeeType,
            ScannedEmployeeName: e.scannedEmployeeName,
            ScannedEmployeeContactNumber: e.mobileNumber,
            ScanDate: e.scannedDate,
            ScanTime: e.scannedTime,
            VisitorEmail: e.scannedEmployeeEmail,
            ParkName: e.parKName,
          },
          'n'
        );
      });
      this.downloadFileService.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 3) {
      this.workbook = new Workbook();
      console.log('emp');
      reportname = 'Employee Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Company', key: 'Company', width: 10 },
        { header: 'Employee Name', key: 'EmployeeName', width: 10 },
        { header: 'Verification Status', key: 'VerificationStatus', width: 10 },
        { header: 'VMS Status', key: 'VMSStatus', width: 10 },
        { header: 'Mobile Number', key: 'MobileNumber', width: 10 },
        { header: 'Employee Email', key: 'EmployeeEmail', width: 10 },
      ];

      let data;
      this.getEmployeeReportData();
      data = this.employeesList;
      let srNo: number = 0;
      data.forEach((e) => {
        srNo = srNo + 1;
        this.worksheet.addRow(
          {
            SrNo: srNo,
            Company: e.companyName,
            EmployeeName: e.employeeName,
            VerificationStatus: e.verificationStatus,
            VMSStatus: e.vmsStatus,
            MobileNumber: e.mobileNumber,
            EmployeeEmail: e.employeeEmail,
          },
          'n'
        );
      });
      this.downloadFileService.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 1) {
      this.workbook = new Workbook();
      console.log('vms');

      reportname = 'VMS Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        // { header: 'System Record Id', key: 'SystemRecordId', width: 10 },
        { header: 'Badge No', key: 'badgeNumber', width: 10 },
        { header: 'Visitor Name', key: 'VisitorName', width: 10 },
        { header: 'Visitor Email', key: 'VisitorEmail', width: 10 },
        { header: 'Visitor MobileNo', key: 'VisitorMobileNumber', width: 10 },

        { header: 'Visitor Company', key: 'VisitorCompany', width: 10 },
        { header: 'InviteType', key: 'inviteType', width: 10 },

        { header: 'Visitor VehicleType', key: 'visitorVehicleType', width: 10 },
        {
          header: 'Visitor Vehicle Number',
          key: 'visitorVehicleNumber',
          width: 10,
        },

        { header: 'DateOfVisit', key: 'DateOfVisit', width: 10 },
        { header: 'Time-In', key: 'timeIn', width: 10 },
        { header: 'Time-out', key: 'timeOut', width: 10 },
        {
          header: 'Badge Returned Status',
          key: 'badgeReturnedStatus',
          width: 10,
        },
        // { header: 'Time-out', key: 'timeOut', width: 10 },
        { header: 'Host Name', key: 'HostName', width: 10 },
        { header: 'Host Company', key: 'HostCompany', width: 10 },
        { header: 'Host Email', key: 'HostEmail', width: 10 },

        { header: 'Host Mobile no', key: 'HostMobileno', width: 10 },
        // { header: 'Invite Type', key: 'inviteType', width: 10 },
        { header: 'Invite Type', key: 'invitationType', width: 10 },

        { header: 'Purpose', key: 'purpose', width: 10 },
        { header: 'Purpose Category', key: 'purposeCategory', width: 10 },

        // { header: 'Park Name', key: 'ParkName', width: 10 },
        { header: 'Building', key: 'Building', width: 10 },
        { header: 'photo Id', key: 'photoId', width: 10 },
        { header: 'Gate.No', key: 'gateNo', width: 10 },
        { header: 'Status', key: 'status', width: 10 },
      ];

      let data;
      this.getVMSReportData();
      data = this.vmsList;

      data.forEach((e, i) => {
        this.worksheet.addRow(
          {
            SrNo: i + 1,
            // SystemRecordId: e.systemRecordId,
            badgeNumber: e.badgeNumber,
            VisitorName: e.visitorName,
            VisitorEmail: e.visitorEmail,
            VisitorMobileNumber: this.dateFormat(e.visitorMobileNumber),
            VisitorCompany: e.visitorCompany,
            inviteType: e.inviteType,
            visitorVehicleType: e.visitorVehicleType,
            visitorVehicleNumber: e.visitorVehicleNumber,
            DateOfVisit: e.dateOfVisit,
            timeIn: e.timeIn,
            timeOut: e.timeOut,
            badgeReturnedStatus: e.badgeReturnedStatus,
            HostName: e.hostName,
            HostCompany: e.hostCompany,
            HostEmail: e.hostEmail,
            HostMobileno: this.dateFormat(e.hostMobileno),
            invitationType: this.formatString(e.invitationType),
            purpose: e.purpose,
            purposeCategory: e.purposeCategory,
            // ParkName: e.parkName,
            Building: e.building,
            photoId: e.photoIdType,
            gateNo: e.gateNo,
            status:
              this.formatString(e.invitationType) == 'Bulk Invite'
                ? e?.status
                : '',
          },
          'n'
        );
      });
      this.downloadFileService.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 2) {
      this.workbook = new Workbook();

      reportname = 'Events Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Event Title', key: 'EventTitle', width: 10 },
        { header: 'Event Category', key: 'EventCategory', width: 10 },
        { header: 'Park Name', key: 'ParkName', width: 10 },
        { header: 'Participation Type', key: 'EventParticipantType', width: 10 },
        { header: 'Event Start Date', key: 'startDate', width: 10 },
        { header: 'Event End Date', key: 'endDate', width: 10 },
        // { header: 'Participant Type', key: 'ParticipantType', width: 10 },
        // { header: 'Team Name', key: 'TeamName', width: 10 },
        { header: 'Participation (Total Count)', key: 'ParticipantsCount', width: 10 },
        { header: 'Guest (Total Count)', key: 'GuestsCount', width: 10 },
        // { header: 'Participant Company', key: 'ParticipantsCompany', width: 10 },
        // { header: 'Captain Name', key: 'CaptainName', width: 10 },
        // { header: 'Captain Mobile no', key: 'CaptainPhone', width: 10 },
        // { header: 'Captain Email', key: 'CaptainEmail', width: 10 },
        // { header: 'Participant Name(s)', key: 'Participants', width: 10 },
        // { header: 'Participant Email(s)', key: 'ParticipantsEmail', width: 10 },
        // { header: 'Attendance', key: 'Attendance', width: 10 },
        // { header: 'Feedback', key: 'Feedback', width: 10 },
        // { header: 'Event Initiated By', key: 'EventinitiatedBy', width: 10 },
      ];

      let data;
      this.getEventsReportData();
      data = this.eventList;
      let srNo: number = 0;
      data.forEach((e) => {
        srNo = srNo + 1;
        this.worksheet.addRow(
          {
            SrNo: srNo,
            EventTitle: e.eventTitle,
            EventCategory: e.eventCategory,
            ParkName: e.parkName,
            EventParticipantType: e.eventParticipantType,
            startDate: this.formatDateAll(e.eventStartDate, 'date'),
            endDate: this.formatDateAll(e.eventEndDate, 'date'),
            // ParticipantType: e.participantType,
            // TeamName: e.teamName,
            ParticipantsCount: e.participantsCount,
            GuestsCount: e?.guestsCount || 0,
            // ParticipantsCompany: e.participantsCompany,
            // CaptainName: e.captain?.name,
            // CaptainPhone: e.captain?.phone,
            // CaptainEmail: e.captain?.email,
            // Participants: e.participants,
            // ParticipantsEmail: e.participantsEmail,
            // Attendance: e.attendance,
            // Feedback: e.feedback,
            // EventinitiatedBy: e.eventCreatedBy,
          },
          'n'
        );
      });
      this.downloadFileService.exportExcel(this.workbook, data, reportname);
    } else if (this.selectedIndex == 4) {
      let facility = [
        'TRANNUM',
        'TRANSACTION ID',
        'USERNAME',
        'TOTAL AMOUNT',
        'IGST',
        'SGST',
        'CGST',
        'PAYMENT DATE',
        'TIMESTAM',
        'PAYMENT STATUS',
        'BOOKING ID',
      ];
      let meetingRoom = [
        'TRANNUM',
        'TRANSACTION ID',
        'USERNAME',
        'TOTAL AMOUNT',
        'IGST',
        'SGST',
        'CGST',
        'PAYMENT DATE',
        'TIMESTAM',
        'PAYMENT STATUS',
        'BOOKING ID',
      ];
      let pms = [
        'TRANNUM',
        'TRANSACTION ID',
        'USERNAME',
        'TOTAL AMOUNT',
        'IGST',
        'SGST',
        'CGST',
        'PAYMENT DATE',
        'TIMESTAM',
        'PAYMENT STATUS',
        'BOOKING ID',
      ];
      const header =
        this.paymentModule == 2
          ? facility
          : this.paymentModule == 1
            ? pms
            : meetingRoom;

      let data;
      let tempRow = [];
      let srNo: number = 0;
      this.getPaymentRecieptReport();
      data = this.paymentReceiptData;
      data.forEach((e) => {
        srNo = srNo + 1;
        tempRow.push(
          this.paymentModule == 2
            ? [
              srNo,
              e?.transactionId,
              e?.userName,
              e?.totalAmount,
              e?.igst,
              e?.sgst,
              e?.cgst,
              e?.paymentDate,
              e?.timeStamp,
              e?.paymentStatus,
              e?.bookingId,
            ]
            : this.paymentModule == 1
              ? [
                srNo,
                e?.transactionId,
                e?.userName,
                e?.totalAmount,
                e?.igst,
                e?.sgst,
                e?.cgst,
                e?.paymentDate,
                e?.timeStamp,
                e?.paymentStatus,
                e?.bookingId,
              ]
              : [
                srNo,
                e?.transactionId,
                e?.userName,
                e?.totalAmount,
                e?.igst,
                e?.sgst,
                e?.cgst,
                e?.paymentDate,
                e?.timeStamp,
                e?.paymentStatus,
                e?.bookingId,
              ]
        );
      });

      let workbook = new Workbook();
      reportname = 'Payment Receipt Report';
      let worksheet = workbook.addWorksheet(reportname);
      worksheet.addRow(['FinReceipts']);
      worksheet.addRow(header);
      tempRow.forEach((d) => {
        worksheet.addRow(d);
      });
      this.downloadFileService.exportExcel(workbook, tempRow, reportname);
    } else if (this.selectedIndex == 5) {
      const header = [
        'TRANNUM',
        'PROPERTY',
        'PERSON',
        'OFFSET',
        'AMOUNT',
        'DATE',
        'POSTMONTH',
        'ACCOUNT',
        'ACCRUAL',
        'NOTES',
        'DISPLAYTYPE',
        'TAXAMOUNT1',
        'TAXAMOUNT2',
        'FROMDATE',
        'TODATE',
        'TAXPOINTDATE',
        'VATTRANTYPEID',
        'VATRATEID',
        'TRANDATE',
        'INTERNATIONALPAYMENTTYPE ',
        'NOTES2',
        'FUNCTIONALCURRENCYAMOUNT',
        'JOB',
        'CATEGORY',
        'CostCode',
        'Contract',
        'TRANFIELD1',
        'TRANFIELD2',
        'TRANFIELD3',
        'TRANFIELD4',
        'TRANFIELD5',
        'TRANFIELD6',
        'TRANFIELD7',
        'TRANFIELD8',
      ];

      let data;
      this.getPaymentReport();
      let tempData = [];
      let srNo: number = 0;
      data = this.paymentData;
      data.forEach((e) => {
        srNo = srNo + 1;
        tempData.push([
          srNo,
          e?.property,
          e?.person,
          e?.offSet,
          e?.amount,
          e?.date,
          e?.postMonth,
          e?.account,
          e?.accural,
          e?.notes,
          e?.displayType,
          e?.taxAmount1,
          e?.taxAmount2,
          e?.fromDate,
          e?.toDate,
          e?.taxpointdate,
          e?.vatronTypeid,
          e?.vatrotid,
          ,
          // (e?.transactionDate),
          e?.internationalpaymenttype,
          e?.notes2,
          e?.functiionalCurrencyAmount == 0 ? '' : e?.functiionalCurrencyAmount,
          e?.job,
          e?.category,
          e?.costCode,
          e?.contract,
          e?.transfield1,
          e?.transfield2,
          e?.transfield3,
          e?.transfield4,
          e?.transfield5,
          e?.transfield6,
          e?.transfield7,
          e?.transfield8,
        ]);
      });

      let workbook = new Workbook();
      reportname = 'Payment Charge Report';
      let worksheet = workbook.addWorksheet(reportname);
      worksheet.addRow(['FinCharges']);
      worksheet.addRow(header);
      tempData.forEach((d) => {
        worksheet.addRow(d);
      });
      this.downloadFileService.exportExcel(workbook, tempData, reportname);
    } else if (this.selectedIndex == 60) {
      //For memberhsip report
      this.workbook = new Workbook();
      reportname = 'RFID Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Organisation Name', key: 'organizationName', width: 10 },
        { header: 'Member Name', key: 'memberName', width: 10 },
        { header: 'Member Mobile', key: 'memberMobile', width: 10 },
        { header: 'Member Card Number', key: 'memberCardNo', width: 10 },
        { header: 'Assinged On', key: 'assignedOn', width: 10 },
      ];
      let data;
      data = this.listfrids;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            organizationName: e.organizationName,
            memberName: e.memberName ? e.memberName : '-',
            memberMobile: e.memberMobile ? e.memberMobile : '-',
            memberCardNo: e.memberCardNo,
            assignedOn: e.assignedOn,
          },
          'n'
        );
      });
      this.downloadFileService.exportExcel(this.workbook, data, reportname);
      //this.exportAsExcelFile(this.employees, 'Employee');
    } else if (this.selectedIndex == 6) {
      //For memberhsip report
      this.workbook = new Workbook();
      reportname = 'Survey Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Survey Name', key: 'surveyName', width: 10 },
        { header: 'Survey Type', key: 'surveyType', width: 10 },
        { header: 'Start Date', key: 'startDate', width: 10 },
        { header: 'End Date', key: 'endDate', width: 10 },
        // { header: 'Coupon Assinged', key: 'couponAssigned', width: 10 },
        { header: 'Park Name', key: 'parkName', width: 10 },
        { header: 'Building Name', key: 'buildingNames', width: 10 },
        { header: 'Tenant Name', key: 'tenantNames', width: 10 },
      ];
      let data;
      data = this.listSurvey;
      this.buildingData = '';
      this.tenantData = '';
      data.forEach((e, i) => {
        this.worksheet.addRow(
          {
            SrNo: i + 1,
            surveyName: e.surveyName,
            surveyType: e.surveyType,
            startDate: this.formatDateAll(e.startDate, 'date'),
            endDate: this.formatDateAll(e.endDate, 'date'),
            // couponAssigned: e.couponAssigned,
            // parkName: e.parkName,
            parkNames: e.parkNames.join(', '),
            buildingNames: e.buildingNames.join(', '),
            tenantNames: e.tenantNames.join(', '),
          },
          'n'
        );
      });
      this.downloadFileService.exportExcel(this.workbook, data, reportname);
      //this.exportAsExcelFile(this.employees, 'Employee');
    } else if (this.selectedIndex == 7) {
      //For memberhsip report
      this.workbook = new Workbook();
      reportname = 'Facility Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Faclity Name', key: 'facilityName', width: 10 },
        { header: 'Facility Type', key: 'facilityTypeName', width: 10 },
        // { header: 'Facility Capacity', key: 'facilityCapacity', width: 10 },
        { header: 'Park Name', key: 'parkName', width: 10 },
        // { header: 'Hourly Rate', key: 'rateHourly', width: 10 },
        // { header: 'Additional Hourly Rate', key: 'additionalHourRate', width: 10 },
        // { header: 'Daily Rate', key: 'dailyRate', width: 10 },
        // { header: 'Additional Daily Rate', key: 'additionalDayRate', width: 10 },
        // { header: 'Security Deposit', key: 'securityDeposit', width: 10 },
        { header: 'Booking Type', key: 'bookingTypeName', width: 10 },
        { header: 'Start Date', key: 'startDateTime', width: 10 },
        { header: 'End Date', key: 'endDateTime', width: 10 },
        { header: 'Duration(Hours)', key: 'duration', width: 10 },
        { header: 'Total Amount', key: 'totalAmount', width: 10 },
        { header: 'Created By', key: 'createdBy', width: 10 },
        { header: 'Payment Status', key: 'paymentStatus', width: 10 },
        { header: 'Refund Status', key: 'refundStatus', width: 10 },
        { header: 'Transaction Date', key: 'transactionDate', width: 10 },
        { header: 'Refund Initiation Date', key: 'refundInitiationDate', width: 10 },
        { header: 'Refund Amount', key: 'refundAmount', width: 10 },
        { header: 'Transaction ID', key: 'transactionId', width: 10 },
      ];
      let data;
      data = this.listFacility;
      data.forEach((e, i) => {
        this.worksheet.addRow(
          {
            SrNo: i + 1,
            facilityName: e.facilityName,
            facilityTypeName: e.facilityTypeName,
            // facilityCapacity: e.facilityCapacity,
            parkName: e.parkName,
            // rateHourly: '₹' + e.rateHourly,
            // additionalHourRate: '₹' + e.additionalHourRate,
            // dailyRate: '₹' + e.dailyRate,
            // additionalDayRate: '₹' + e.additionalDayRate,
            // securityDeposit: '₹' + e.securityDeposit,
            bookingTypeName: e.bookingTypeName,
            startDateTime: this.formatDateAll(e.startDateTime, 'date') + ' ' + this.formatTimeAll(e.startDateTime, 'time'),
            endDateTime: this.formatDateAll(e.endDateTime, 'date') + ' ' + this.formatTimeAll(e.endDateTime, 'time'),
            duration: e.duration,
            totalAmount: '₹' + e.totalAmount,
            createdBy: e.createdBy,
            paymentStatus: e.paymentStatus,
            refundStatus: e.refundStatus,
            transactionDate: this.formatDateAll(e.transactionDate, 'date'),
            refundInitiationDate: this.formatDateAll(e.refundInitiationDate, 'date'),
            refundAmount: e.refundAmount != null ? '₹' + e.refundAmount : 0.00,
            transactionId: e.transactionId,
          },
          'n'
        );
      });
      this.downloadFileService.exportExcel(this.workbook, data, reportname);
      //this.exportAsExcelFile(this.employees, 'Employee');
    } else if (this.selectedIndex == 8) {
      //For memberhsip report
      this.workbook = new Workbook();
      reportname = 'Meeting Room Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Faclity Name', key: 'facilityName', width: 10 },
        { header: 'Facility Type', key: 'facilityTypeName', width: 10 },
        // { header: 'Facility Capacity', key: 'facilityCapacity', width: 10 },
        { header: 'Park Name', key: 'parkName', width: 10 },
        // { header: 'Hourly Rate', key: 'rateHourly', width: 10 },
        // { header: 'Additional Hourly Rate', key: 'additionalHourRate', width: 10 },
        // { header: 'Daily Rate', key: 'dailyRate', width: 10 },
        // { header: 'Additional Daily Rate', key: 'additionalDayRate', width: 10 },
        // { header: 'Security Deposit', key: 'securityDeposit', width: 10 },
        { header: 'Booking Type', key: 'bookingTypeName', width: 10 },
        { header: 'Start Date', key: 'startDateTime', width: 10 },
        { header: 'End Date', key: 'endDateTime', width: 10 },
        { header: 'Duration(Hours)', key: 'duration', width: 10 },
        { header: 'Total Amount', key: 'totalAmount', width: 10 },
        { header: 'Created By', key: 'createdBy', width: 10 },
        { header: 'Payment Status', key: 'paymentStatus', width: 10 },
        { header: 'Refund Status', key: 'refundStatus', width: 10 },
        { header: 'Transaction Date', key: 'transactionDate', width: 10 },
        { header: 'Refund Initiation Date', key: 'refundInitiationDate', width: 10 },
        { header: 'Refund Amount', key: 'refundAmount', width: 10 },
        { header: 'Transaction ID', key: 'transactionId', width: 10 },
      ];
      let data;
      data = this.listMeetingRoom;
      data.forEach((e, i) => {
        this.worksheet.addRow(
          {
            SrNo: i + 1,
            facilityName: e.facilityName,
            facilityTypeName: e.facilityTypeName,
            // facilityCapacity: e.facilityCapacity,
            parkName: e.parkName,
            // rateHourly: '₹' + e.rateHourly,
            // additionalHourRate: '₹' + e.additionalHourRate,
            // dailyRate: '₹' + e.dailyRate,
            // additionalDayRate: '₹' + e.additionalDayRate,
            // securityDeposit: '₹' + e.securityDeposit,
            bookingTypeName: e.bookingTypeName,
            startDateTime: this.formatDateAll(e.startDateTime, 'date') + ' ' + this.formatTimeAll(e.startDateTime, 'time'),
            endDateTime: this.formatDateAll(e.endDateTime, 'date') + ' ' + this.formatTimeAll(e.endDateTime, 'time'),
            duration: e.duration,
            totalAmount: '₹' + e.totalAmount,
            createdBy: e.createdBy,
            paymentStatus: e.paymentStatus,
            refundStatus: e.refundStatus,
            transactionDate: this.formatDateAll(e.transactionDate, 'date'),
            refundInitiationDate: this.formatDateAll(e.refundInitiationDate, 'date'),
            refundAmount: e.refundAmount != null ? '₹' + e.refundAmount : 0.00,
            transactionId: e.transactionId,
          },
          'n'
        );
      });
      this.downloadFileService.exportExcel(this.workbook, data, reportname);
      //this.exportAsExcelFile(this.employees, 'Employee');
    }
  }

  DownloadReportPDF() {
    this.PdfReportrows = [];
    if (this.selectedIndex == 0) {
      let head;

      head = [
        [
          'Sr.No',
          'ERT Members Company',
          'Activity Type',
          'ERT Member name',
          'Scanned Employee Type',
          'Scanned Employee Name',
          'Scanned Contact Number',
          'Scan Date',
          'Scan Time',
          'Visitor Email',
          'Park Name',
        ],
      ];
      this.getFirewardenReportData();
      let srNo: number = 0;
      this.fireWardenList.forEach((element) => {
        srNo = srNo + 1;
        var temp = [
          srNo,
          element.ertCompnayName,
          this.selectedActivityType,
          element.ertMbrName,
          element.employeeType,
          element.scannedEmployeeName,
          element.mobileNumber,
          element.scannedDate,
          element.scannedTime,
          element.scannedEmployeeEmail,
          element.parKName,
        ];
        this.PdfReportrows.push(temp);
      });
      this.downloadFileService.openPDF(
        this.PdfReportrows,
        'Fire Warden Report - Company',
        head,
        'l'
      );
    } else if (this.selectedIndex == 2) {
      let head;

      head = [
        [
          'Sr.No',
          'Event Title',
          'Event Category',
          'Park',
          // 'Participation Type',
          'Participation Type',
          'Event Start Date',
          'Event End Date',
          // 'Team Name',
          'Participation (Total Count)',
          'Guest (Total Count)',
          // 'Participant Company',
          // 'Participant Captain Name',
          // 'Captain’s Contact Number',
          // 'Captain Email',
          // 'Participant Name(s)',
          // 'Participant Email(s)',
          // 'Attendance',
          // 'Feedback',
          // 'Event initiated By',
        ],
      ];
      this.getEventsReportData();
      let srNo: number = 0;
      this.eventList.forEach((element) => {
        srNo = srNo + 1;
        var temp = [
          srNo,
          element?.eventTitle,
          element?.eventCategory,
          element?.parkName,
          // element?.participantType,
          element?.eventParticipantType,
          this.formatDateAll(element?.eventStartDate, 'date'),
          this.formatDateAll(element?.eventEndDate, 'date'),
          // element?.teamName,
          element?.participantsCount,
          element?.guestsCount || 0,
          // element?.participantsCompany,
          // element?.captain?.name,
          // element?.captain?.phone,
          // element?.captain?.email,
          // element?.participants,
          // element?.participantsEmail,
          // element?.attendance,
          // element?.feedback,
          // element?.eventCreatedBy,
        ];
        this.PdfReportrows.push(temp);
      });
      this.downloadFileService.openPDF(
        this.PdfReportrows,
        'Events Report',
        head,
        'landscape'
      );
    } else if (this.selectedIndex == 1) {
      let head;

      head = [
        [
          'Sr.No',
          // 'System Record Id',
          'Badge Number',
          'Visitor Name',
          'Visitor Email',
          'Visitor MobileNo',
          'Visitor Company',
          'Invite Type',
          'Visitor VehicleType',
          'Visitor Vehicle Number',
          'DateOfVisit',
          'Time-In',
          'Time-Out',
          'Badge Returned Status',
          'Host Name',
          'Host Company',
          'Host Email',
          'Host Mobile no',
          'Invitation Type',
          'Purpose',
          'Purpose Category',
          // 'Park Name',
          'Building',
          'Photo Id',
          'GateNo',
          'Status',
        ],
      ];
      this.getVMSReportData;
      this.vmsList.forEach((e, i) => {
        var temp = [
          i + 1,
          // e.systemRecordId,
          e.badgeNumber,
          e.visitorName,
          e.visitorEmail,
          this.dateFormat(e.visitorMobileNumber),
          e.visitorCompany,
          e.inviteType,
          e.visitorVehicleType,
          e.visitorVehicleNumber,
          e.dateOfVisit,
          e.timeIn,
          e.timeOut,
          e.badgeReturnedStatus,
          e.hostName,
          e.hostCompany,
          e.hostEmail,
          this.dateFormat(e.hostMobileno),
          this.formatString(e.invitationType),
          e.purpose.replace(/^\s+|\s+$/gm, ''),
          e.purposeCategory,
          // e.parkName,
          e.building,
          e.photoIdType,
          e.gateNo,
          this.formatString(e.invitationType) == 'Bulk Invite' ? e?.status : '',
        ];
        this.PdfReportrows.push(temp);
      });
      this.downloadFileService.openPDF(
        this.PdfReportrows,
        'VMS Report',
        head,
        'landscape'
      );
    } else if (this.selectedIndex == 3) {
      let head;

      head = [
        [
          'Sr.No',
          'Company',
          'Employee Name',
          'Verification Status',
          'VMS Status',
          'Mobile Number',
          'Employee Email',
        ],
      ];
      this.getEmployeeReportData();
      let srNo: number = 0;
      this.employeesList.forEach((element) => {
        srNo = srNo + 1;
        var temp = [
          srNo,
          element.companyName,
          element.employeeName,
          element.verificationStatus,
          element.vmsStatus,
          element.mobileNumber,
          element.employeeEmail,
        ];
        this.PdfReportrows.push(temp);
      });
      this.downloadFileService.openPDF(
        this.PdfReportrows,
        'Employee Report',
        head,
        'p'
      );
    } else if (this.selectedIndex == 60) {
      let head = [
        [
          'Sr.No',
          'Organisation Name',
          'Member Name',
          'Member Mobile',
          'Member Card Number',
          'Assinged On',
        ],
      ];
      this.listfrids.forEach((element) => {
        var temp = [
          element.srNo,
          element.organizationName,
          element.memberName ? element.memberName : '-',
          element.memberMobile ? element.memberMobile : '-',
          element.memberCardNo,
          element.assignedOn,
        ];
        this.PdfReportrows.push(temp);
      });
      this.downloadFileService.openPDF(this.PdfReportrows, 'RFID Report', head, 'l');
    } else if (this.selectedIndex == 6) {
      let head = [
        [
          'Sr.No',
          'Survey Name',
          'Survey Type',
          'Start Date',
          'End Date',
          // 'Coupon Assinged',
          'Park Name',
          'Building Name',
          'Tenant Name',
        ],
      ];
      this.listSurvey.forEach((element, i) => {
        var temp = [
          i + 1,
          element.surveyName,
          element.surveyType,
          this.formatDateAll(element.startDate, 'date'),
          this.formatDateAll(element.endDate, 'date'),
          // element.couponAssigned,
          // element.parkName,
          element.parkNames.join(', '),
          element.buildingNames.join(', '),
          element.tenantNames.join(', '),
        ];
        this.PdfReportrows.push(temp);
      });
      this.downloadFileService.openPDF(this.PdfReportrows, 'Survey Report', head, 'l');
    } else if (this.selectedIndex == 7) {
      let head = [
        [
          'Sr.No',
          'Faclity Name',
          'Facility Type',
          // 'Facility Capacity',
          'Park Name',
          // 'Hourly Rate',
          // 'Additional Hourly Rate',
          // 'Daily Rate',
          // 'Additional Daily Rate',
          // 'Security Deposit',
          'Booking Type',
          'Start Date',
          'End Date',
          'Duration(Hours)',
          'Total Amount',
          'Created By',
          'Payment Status',
          'Refund Status',
          'Transaction Date',
          'Refund Initiation Date',
          'Refund Amount',
          'Transaction ID'
        ],
      ];
      this.listFacility.forEach((element, i) => {
        var temp = [
          i + 1,
          element.facilityName,
          element.facilityTypeName,
          // element.facilityCapacity,
          element.parkName,
          // '₹' + element.rateHourly,
          // '₹' + element.additionalHourRate,
          // '₹' + element.dailyRate,
          // '₹' + element.additionalDayRate,
          // '₹' + element.securityDeposit,
          element.bookingTypeName,
          this.formatDateAll(element.startDateTime, 'date') + ' ' + this.formatTimeAll(element.startDateTime, 'time'),
          this.formatDateAll(element.endDateTime, 'date') + ' ' + this.formatTimeAll(element.endDateTime, 'time'),
          element.duration,
          '₹' + element.totalAmount,
          element.createdBy,
          element.paymentStatus,
          element.refundStatus,
          this.formatDateAll(element.transactionDate, 'date'),
          this.formatDateAll(element.refundInitiationDate, 'date'),
          element.refundAmount != null ? '₹' + element.refundAmount : 0.00,
          element.transactionId,
        ];
        this.PdfReportrows.push(temp);
      });
      this.downloadFileService.openPDF(this.PdfReportrows, 'Facility Report', head, 'l');
    } else if (this.selectedIndex == 8) {
      let head = [
        [
          'Sr.No',
          'Faclity Name',
          'Facility Type',
          // 'Facility Capacity',
          'Park Name',
          // 'Hourly Rate',
          // 'Additional Hourly Rate',
          // 'Daily Rate',
          // 'Additional Daily Rate',
          // 'Security Deposit',
          'Booking Type',
          'Start Date',
          'End Date',
          'Duration(Hours)',
          'Total Amount',
          'Created By',
          'Payment Status',
          'Refund Status',
          'Transaction Date',
          'Refund Initiation Date',
          'Refund Amount',
          'Transaction ID'
        ],
      ];
      this.listMeetingRoom.forEach((element, i) => {
        var temp = [
          i + 1,
          element.facilityName,
          element.facilityTypeName,
          // element.facilityCapacity,
          element.parkName,
          // '₹' + element.rateHourly,
          // '₹' + element.additionalHourRate,
          // '₹' + element.dailyRate,
          // '₹' + element.additionalDayRate,
          // '₹' + element.securityDeposit,
          element.bookingTypeName,
          this.formatDateAll(element.startDateTime, 'date') + ' ' + this.formatTimeAll(element.startDateTime, 'time'),
          this.formatDateAll(element.endDateTime, 'date') + ' ' + this.formatTimeAll(element.endDateTime, 'time'),
          element.duration,
          '₹' + element.totalAmount,
          element.createdBy,
          element.paymentStatus,
          element.refundStatus,
          this.formatDateAll(element.transactionDate, 'date'),
          this.formatDateAll(element.refundInitiationDate, 'date'),
          element.refundAmount != null ? '₹' + element.refundAmount : 0.00,
          element.transactionId,
        ];
        this.PdfReportrows.push(temp);
      });
      this.downloadFileService.openPDF(this.PdfReportrows, 'Meeting Room Report', head, 'l');
    }
  }

  formatString(data) {
    if (data !== null || data !== undefined) {
      let trimmedData = JSON.stringify(data?.replace(/ /g, ''));

      if (trimmedData?.substring(trimmedData.length - 7) == 'Invite"')
        return JSON.parse(
          trimmedData?.substring(0, trimmedData.length - 7) +
          ' ' +
          trimmedData?.substring(trimmedData.length - 7)
        );
      return data;
    }
  }

  paginationCount(val) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  formatDate(date) {
    if (date !== undefined || date !== null || date !== '') {
      const splitDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(
        splitDate[2],
        splitDate[1] - 1,
        splitDate[0]
      );
    }
  }

  fomatMonth(date) {
    console.log(date);
    if (date !== undefined || date !== null || date !== '') {
      const splitDate = date.split('/');
      return this.dateSrv.convertstringToMonth(splitDate[0] - 1);
    }
  }

  getTentantsRfid() {
    this.reportsLoaded = false;
    this.reportService.getTenant().subscribe((r) => {
      this.tenants = r.data.tenants;
      const allOpt = {
        id: null,
        companyName: 'All',
      };
      this.tenants.unshift(allOpt);
      if (this.selectedOrganizationId == null && this.tenants.length > 0) {
        this.selectedOrganizationId = this.tenants[0].id;
        this.selectOrgatizationRfid(this.tenants[0]);
      }
      // this.reportsLoaded = true;
    });
  }

  selectOrgatizationRfid(item) {
    if (item.id !== null)
      if (this.multiSelectionOrganizations.includes(item.id))
        this.multiSelectionOrganizations.splice(
          this.multiSelectionOrganizations.indexOf(item.id),
          1
        );
      else this.multiSelectionOrganizations.push(item.id);
    else this.multiSelectionOrganizations = [];

    let length = this.multiSelectionOrganizations.length - 1;
    this.selctionlength = length;
    this.selectedOrganizationId = item.id;
    this.selectedOrganzation = item.companyName;

    if (item.name != 'All') {
      this.selectedOrganzation = this.tenants.find(
        (x) =>
          x.id ==
          this.multiSelectionOrganizations[
          this.multiSelectionOrganizations.length - 1
          ]
      ).companyName;
    } else {
      this.selectedOrganzation = item.companyName;
    }

    this.getRfidsReport();
  }

  getRfidsReport() {
    this.totalRows = 0;
    this.listfrids = [];

    if (this.multiSelectionOrganizations.length > 0) {
      this.reportService
        .getRfids(
          this.multiSelectionOrganizations,
          this.selectedDate,
          this.selectedToDate
        )
        .subscribe((r) => {
          if (r.length > 0) this.listfrids = [...this.listfrids, ...r];
          this.totalRows = this.listfrids?.length;
          this.reportsLoaded = true;
          this.handlePageChangeRfids(1);
        });
    } else {
      this.reportService
        .getRfids(null, this.selectedDate, this.selectedToDate)
        .subscribe((r) => {
          if (r.length > 0) this.listfrids = [...r];
          this.totalRows = this.listfrids?.length;
          this.reportsLoaded = true;
          this.handlePageChangeRfids(1);
        });
    }
  }

  handlePageChangeRfids(event) {
    this.page = event;
    console.log('pagination clicked');

    this.creditPoint = this.listfrids.slice(
      0,
      this.listfrids.length < 10
        ? this.listfrids.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  getTypeSurvey() {
    this.reportsLoaded = false;
    this.mainSurveyTypes = [];
    this.mainSurveyTypes.push({
      surveyTypeId: "General",
      surveyTypeName: "General"
    },
      {
        surveyTypeId: "Event",
        surveyTypeName: "Event"
      }
    );
    const allOpt = {
      surveyTypeId: null,
      surveyTypeName: "All"
    }
    this.mainSurveyTypes.unshift(allOpt);
    // let length = this.mainSurveyTypes.length - 1;
    // this.selctionlength = length;
    this.selectedSurveyName = this.mainSurveyTypes[0].surveyTypeName;

    if (this.mainSurveyTypes.length > 0) {
      this.selectedOrganizationId = this.mainSurveyTypes[0].surveyTypeId;
      this.selectOrgatizationSurvey(this.mainSurveyTypes[0]);
    }
  }

  selectOrgatizationSurvey(item) {
    console.log(item);
    if (item.surveyTypeId !== null)
      if (this.multiSelectionOrganizations.includes(item.surveyTypeId))
        this.multiSelectionOrganizations.splice(
          this.multiSelectionOrganizations.indexOf(item.surveyTypeId),
          1
        );
      else this.multiSelectionOrganizations.push(item.surveyTypeId);
    else this.multiSelectionOrganizations = [];

    console.log(this.multiSelectionOrganizations);
    let length = this.multiSelectionOrganizations.length;
    this.selctionlength = length;
    console.log(this.selctionlength);
    this.selectedOrganizationId = item.surveyTypeId;
    this.selectedOrganzation = item.surveyTypeName;

    if (item.surveyTypeName != 'All') {
      this.selectedOrganzation = this.mainSurveyTypes.find((x: { surveyTypeName: any; }) => x.surveyTypeName == this.multiSelectionOrganizations[this.multiSelectionOrganizations.length - 1]).surveyTypeName;
    } else {
      this.selectedOrganzation = item.surveyTypeName;
    }

    this.getSurveyReport();
  }

  getSurveyReport() {
    this.totalRows = 0;
    this.listSurvey = [];

    console.log(this.multiSelectionOrganizations.length);

    if (this.multiSelectionOrganizations.length > 0) {
      this.reportService
        .getSurveyReport(
          this.multiSelectionOrganizations,
          this.selectedDate,
          this.selectedToDate
        )
        .subscribe((r) => {
          console.log(r.list.length);
          if (r.list.length > 0) {
            this.listSurvey = [...this.listSurvey, ...r.list];
            this.totalRows = this.listSurvey?.length;
            console.log(this.listSurvey);
            this.reportsLoaded = true;
            this.handlePageChangeSurvey(1);
          }
        });
    } else {
      this.reportService
        .getSurveyReport([], this.selectedDate, this.selectedToDate)
        .subscribe((r) => {
          console.log(r.list.length);
          if (r.list.length > 0) {
            this.listSurvey = [...r.list];
            this.totalRows = this.listSurvey?.length;
            console.log(this.listSurvey);
            this.reportsLoaded = true;
            this.handlePageChangeSurvey(1);
          } else {
            this.listSurvey = [...this.listSurvey];
            this.reportsLoaded = true;
            this.handlePageChangeSurvey(1);
          }
        });
    }
  }

  handlePageChangeSurvey(event) {
    this.page = event;
    this.indexPage = this.page;
    console.log('pagination clicked');

    console.log(this.listSurvey);

    this.creditPoint = this.listSurvey.slice(
      0,
      this.listSurvey.length < 10
        ? this.listSurvey.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  getTypeFacility() {
    this.reportsLoaded = false;
    this.mainFacilityTypes = [];
    this.mainFacilityTypes.push({
      facilityTypeId: "confirm",
      facilityTypeName: "Confirm"
    },
      {
        facilityTypeId: "cancel",
        facilityTypeName: "Cancel"
      }
    );
    const allOpt = {
      facilityTypeId: null,
      facilityTypeName: "All"
    }
    this.mainFacilityTypes.unshift(allOpt);
    // let length = this.mainFacilityTypes.length - 1;
    // this.selctionlength = length;
    this.selectedFacilityName = this.mainFacilityTypes[0].facilityTypeName;

    if (this.mainFacilityTypes.length > 0) {
      this.selectedOrganizationId = this.mainFacilityTypes[0].facilityTypeId;
      this.selectOrgatizationFacility(this.mainFacilityTypes[0]);
    }
  }

  getTypeMeetingRoom() {
    this.reportsLoaded = false;
    this.mainMeetingRoomTypes = [];
    this.mainMeetingRoomTypes.push({
      meetingTypeId: "Confirm",
      meetingTypeName: "Confirm"
    },
      {
        meetingTypeId: "Cancel",
        meetingTypeName: "Cancel"
      }
    );
    const allOpt = {
      meetingTypeId: null,
      meetingTypeName: "All"
    }
    this.mainMeetingRoomTypes.unshift(allOpt);
    // let length = this.mainMeetingRoomTypes.length - 1;
    // this.selctionlength = length;
    this.selectedMeetingRoomName = this.mainMeetingRoomTypes[0].meetingTypeName;

    if (this.mainMeetingRoomTypes.length > 0) {
      this.selectedOrganizationId = this.mainMeetingRoomTypes[0].meetingTypeId;
      this.selectOrgatizationMeetingRoom(this.mainMeetingRoomTypes[0]);
    }
  }

  selectOrgatizationFacility(item) {
    console.log(item);
    if (item.facilityTypeId !== null)
      if (this.multiSelectionOrganizations.includes(item.facilityTypeId))
        this.multiSelectionOrganizations.splice(
          this.multiSelectionOrganizations.indexOf(item.facilityTypeId),
          1
        );
      // else this.multiSelectionOrganizations.push(item.facilityTypeId);
      else this.multiSelectionOrganizations = item.facilityTypeId;
    else this.multiSelectionOrganizations = [];

    console.log(this.multiSelectionOrganizations);
    let length = this.multiSelectionOrganizations.length;
    this.selctionlength = length;
    console.log(this.selctionlength);
    this.selectedOrganizationId = item.facilityTypeId;
    this.selectedOrganzation = item.facilityTypeName;

    this.selectedFacilityName = item.facilityTypeName;

    if (item.facilityTypeName != 'All') {
      //this.selectedOrganzation = this.mainFacilityTypes.find((x: { facilityTypeName: any; }) => x.facilityTypeName == this.multiSelectionOrganizations[this.multiSelectionOrganizations.length - 1]).facilityTypeName;
    } else {
      //this.selectedOrganzation = item.facilityTypeName;
    }

    this.getFacilityReport();
  }

  selectOrgatizationMeetingRoom(item) {
    console.log(item);
    if (item.meetingTypeId !== null)
      if (this.multiSelectionOrganizations.includes(item.meetingTypeId))
        this.multiSelectionOrganizations.splice(
          this.multiSelectionOrganizations.indexOf(item.meetingTypeId),
          1
        );
      // else this.multiSelectionOrganizations.push(item.meetingTypeId);
      else this.multiSelectionOrganizations = item.meetingTypeId;
    else this.multiSelectionOrganizations = [];

    console.log(this.multiSelectionOrganizations);
    let length = this.multiSelectionOrganizations.length;
    this.selctionlength = length;
    console.log(this.selctionlength);
    this.selectedOrganizationId = item.meetingTypeId;
    this.selectedOrganzation = item.meetingTypeName;

    this.selectedMeetingRoomName = item.meetingTypeName;

    if (item.meetingTypeName != 'All') {
      //this.selectedOrganzation = this.mainFacilityTypes.find((x: { meetingTypeName: any; }) => x.meetingTypeName == this.multiSelectionOrganizations[this.multiSelectionOrganizations.length - 1]).facilityTypeName;
    } else {
      //this.selectedOrganzation = item.meetingTypeName;
    }
    this.page = 0;
    this.indexPage = 1;
    this.getMeetingRoomReport();
  }

  getFacilityReport() {
    this.totalRows = 0;
    this.listFacility = [];

    console.log(this.multiSelectionOrganizations.length);

    if (this.multiSelectionOrganizations.length > 0) {
      this.reportService
        .getFacilityReport(
          this.multiSelectionOrganizations,
          this.selectedDate,
          this.selectedToDate
        )
        .subscribe((r) => {
          console.log(r.list.length);
          if (r.list.length > 0) {
            this.listFacility = [...this.listFacility, ...r.list];
            this.totalRows = this.listFacility?.length;
            console.log(this.listFacility);
            this.reportsLoaded = true;
            this.handlePageChangeFacility(1);
          } else { 
            this.totalRows = 0;
          }
        });
    } else {
      this.reportService
        .getFacilityReport('all', this.selectedDate, this.selectedToDate)
        .subscribe((r) => {
          console.log(r.list?.length);
          if (r.list.length > 0) {
            this.listFacility = [...r.list];
            this.totalRows = this.listFacility?.length;
            console.log(this.listFacility);
            this.reportsLoaded = true;
            this.handlePageChangeFacility(1);
          } else {
            this.totalRows = 0;
            this.listFacility = [...this.listFacility];
            this.reportsLoaded = true;
            this.handlePageChangeFacility(1);
          }
        });
    }
  }

  getMeetingRoomReport() {
    this.totalRows = 0;
    this.listMeetingRoom = [];
    this.totalCountList = 0;

    if (this.pageNo == 0) {
      this.pageNo = 1;
    }

    console.log('pageeee', this.page);
    const MeetingRoomReportInputModel = {
      meetingType: (this.multiSelectionOrganizations.length > 0) ? this.multiSelectionOrganizations : 'All',
      parkId: localStorage.getItem('parkId'),
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      searchTerm: this.searchText,
      pageNo: this.pageNo,
      size: 10, //this.pageSize,
      isAll: this.multiSelectionOrganizations.length == 0 ? true : false,
    };

    this.reportService.getMeetingRoomReportData(MeetingRoomReportInputModel).subscribe(
      (response: any) => {
        if (response.data != null) {
          console.log('s', response);
          this.listMeetingRoom = response.data?.meetingRoomReportResponseModels;
          this.reportsLoaded = true;
          this.totalRows = this.listMeetingRoom?.length;
          this.totalCountList = response?.data.totalCount;
          if (this.listMeetingRoom?.length > 0) {
            this.reportsLoaded = true;
          } else {
            this.reportsLoaded = false;
            this.totalRows = 0;
            this.totalCountList = 0;
          }
        } else {
          this.reportsLoaded = false;
          this.totalRows = 0;
          this.totalCountList = 0;
        }
      },
      (err) => console.log('error', err)
    );
  }

  handlePageChangeFacility(event) {
    this.page = event;
    this.indexPage = this.page;
    console.log('pagination clicked');

    console.log(this.listFacility);

    this.creditPoint = this.listFacility.slice(
      0,
      this.listFacility.length < 10
        ? this.listFacility.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  handlePageChangeMeetingRoom(event) {
    this.pageNo = event;
    this.page = event;
    this.indexPage = this.page;
    this.getMeetingRoomReport();
  }

  formatDateAll(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    else {
      this.tempDate = date.split('T')[1].split(':')
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM'
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type
    }
  }

  formatTimeAll(date, type) {
    if (date == null) return;
    if (type == 'time') {
      this.tempDate = date.split('T')[1].split(':')
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM'
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type
    }
    else {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
  }

  reportDownloadUrl(surveyId) {
    return this.baseUrl + surveyId;
  }

  fetchPage(val) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  downloadExclVms() {
    console.log("Here VMS");

    // const formData_new = new FormData();
    // let isAll = this.multiSelectionInvitationType.length == 0 ? 'true' : 'false';
    // formData_new.append('invitationType', this.multiSelectionInvitationType);
    // formData_new.append('parkId', localStorage.getItem('parkId'));
    // formData_new.append('fromDate', this.selectedDate);
    // formData_new.append('toDate', this.selectedToDate);
    // formData_new.append('searchTerm', this.searchText);
    // formData_new.append('pageNo', this.pageNo.toString());
    // formData_new.append('size', '10');
    // formData_new.append('isAll', isAll);

    const VMSReportInputModel = {
      invitationType: this.multiSelectionInvitationType,
      parkId: localStorage.getItem('parkId'),
      //invitationType: "individualInvite",
      // TenantId: "b8657e8d-c137-46a4-9de0-bdbb01b8fc04", //  localStorage.getItem(AppConstant.localStorage.parkTenantId);
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      searchTerm: this.searchText,
      // pageNo: this.page,
      // size: this.pageNo,
      pageNo: this.pageNo,
      size: 10, //this.pageSize,
      isAll: this.multiSelectionInvitationType.length == 0 ? true : false,
      ReportType: 'Excel',
    };

    // report download with blob response
    this.reportService.submitVmsReport(VMSReportInputModel).subscribe(
      response => {
        this.successmessage = 'Report is downloaded successfully';
        let url = window.URL.createObjectURL(response);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = this.generateFilename('VMSReport_');
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
        this.errormessage = '';
      },
      error => {
        // Handle error
        console.error(error);
        this.errormessage = error;
        this.successmessage = '';
      }
    );
  }

  downloadExclMeetingRoom() {
    const MeetingRoomReportInputModel = {
      meetingType: (this.multiSelectionOrganizations.length > 0) ? this.multiSelectionOrganizations : 'All',
      parkId: localStorage.getItem('parkId'),
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      searchTerm: this.searchText,
      pageNo: this.pageNo,
      size: 10, //this.pageSize,
      isAll: this.multiSelectionOrganizations.length == 0 ? true : false,
      ReportType: 'Excel',
    };

    // report download with blob response
    this.reportService.submitMeetingRoomReport(MeetingRoomReportInputModel).subscribe(
      response => {
        this.successmessage = 'Report is downloaded successfully';
        let url = window.URL.createObjectURL(response);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = this.generateFilename('MeetingRoomReport_');
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
        this.errormessage = '';
      },
      error => {
        // Handle error
        console.error(error);
        this.errormessage = error;
        this.successmessage = '';
      }
    );
  }

  generateFilename(filenamePrefix) {
    var currentDate = new Date();
    var day = currentDate.getDate().toString();
    var month = (currentDate.getMonth() + 1).toString(); // Adding 1 to get the correct month
    var year = currentDate.getFullYear().toString();
    var hour = currentDate.getHours().toString();
    var minute = currentDate.getMinutes().toString();

    // Adding leading zeros if necessary
    if (day.length === 1) {
      day = '0' + day;
    }
    if (month.length === 1) {
      month = '0' + month;
    }
    if (hour.length === 1) {
      hour = '0' + hour;
    }
    if (minute.length === 1) {
      minute = '0' + minute;
    }

    var filename = filenamePrefix + day + '' + month + '' + year + hour + '' + minute + '.xlsx';
    return filename;
  }


  // filterReports(reports1, reports2) {
  //   return reports1.filter(report1 => {
  //     const matchedKey = reports2.find(report2 => report1.key === report2);
  //     return matchedKey;
  //   });
  // }

  filterReports(reports1, reports2) {
    return reports1.filter(report1 => {
      const matchedKey = reports2.some(report2 =>
        report1.key === report2 ||
        report1.key1 === report2 ||
        report1.key2 === report2
      );
      return matchedKey;
    });
  }


}
